import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import type {PayloadAction} from '@reduxjs/toolkit'
import axios from 'axios'

const get = axios.get
const post = axios.post
const api = '/api/regulation-category/'
const rpi = '/api/regulation/'

const handleRequest = async (request: Promise<any>, thunkAPI: any) => {
  try {
    const res = await request
    return res.data
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response.data)
  }
}

// regulation category
export const ListRegulationCategory = createAsyncThunk('reg-cats', (params: {}, thunkAPI) =>
  handleRequest(get(`${api}}list`, params), thunkAPI)
)

export const createRegulationCategory = createAsyncThunk('add-reg-cat', (data: {}, thunkAPI) =>
  handleRequest(post(`${api}}store`, data), thunkAPI)
)

export const editRegulationCategory = createAsyncThunk('edit-reg-cat', (id: string, thunkAPI) =>
  handleRequest(get(`${api}}edit/${id}`), thunkAPI)
)

export const deleteRegulationCategory = createAsyncThunk('del-reg-cat', (id: string, thunkAPI) =>
  handleRequest(get(`${api}}destroy/${id}`), thunkAPI)
)

// regulations
export const ListRegulation = createAsyncThunk('regs', (params: {}, thunkAPI) =>
  handleRequest(get(`${rpi}list`, params), thunkAPI)
)

export const createRegulation = createAsyncThunk('add-reg', (data: {}, thunkAPI) =>
  handleRequest(post(`${rpi}store`, data), thunkAPI)
)

export const editRegulation = createAsyncThunk('edit-reg', (id: string, thunkAPI) =>
  handleRequest(get(`${rpi}edit/${id}`), thunkAPI)
)

export const viewRegulation = createAsyncThunk('view-reg', (id: string, thunkAPI) =>
  handleRequest(get(`${rpi}view/${id}`), thunkAPI)
)

export const deleteRegulation = createAsyncThunk('del-reg', (id: string, thunkAPI) =>
  handleRequest(get(`${rpi}destroy/${id}`), thunkAPI)
)

type RegulationState = {
  record: any
  records: any
  errors: any
}

const initialState: RegulationState = {
  records: {
    data: [],
  },
  record: {},
  errors: '',
}

export const regulationSlice = createSlice({
  name: 'regulation',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(ListRegulationCategory.fulfilled, (state, action: PayloadAction<any>) => {
        state.records = action.payload
      })
      .addCase(editRegulationCategory.fulfilled, (state, action: PayloadAction<any>) => {
        state.record = action.payload
      })
      .addCase(ListRegulation.fulfilled, (state, action: PayloadAction<any>) => {
        state.records = action.payload
      })
      .addCase(editRegulation.fulfilled, (state, action: PayloadAction<any>) => {
        state.record = action.payload
      })
  },
})

export const {reset} = regulationSlice.actions
export default regulationSlice.reducer
